import React, {memo} from "react";
import PropTypes from "prop-types";
import {FaCog} from "react-icons/fa";
import Popover from "../Popover";
import PopoverItem from "../Popover/PopoverItem";
import ProtectedContent from "../protectedContent";

/** This component acts as wrapper around card and renders actions popover at top right corner*/

const CardActions = (props) => {
  const {
    actionsList = [],
    permsForActions = [],
    onSelectAction = () => {},
    cardData = {},
  } = props;
  return (
    <ProtectedContent perms={permsForActions} shouldHaveAllPermissions={false}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginTop: "10px",
        }}
      >
        <Popover icon={FaCog}>
          {actionsList &&
            actionsList.map((action, index) => {
              const {label, icon, perms, condition = ""} = action;
              if (condition && cardData[condition] === false) {
                return null;
              }

              return (
                <PopoverItem
                  key={index}
                  onContentSelection={(label) => onSelectAction(label)}
                  label={label}
                  icon={icon}
                  perms={perms}
                />
              );
            })}
        </Popover>
      </div>
    </ProtectedContent>
  );
};

CardActions.propTypes = {
  /** List of actions which will be passed to action popover component */
  actionsList: PropTypes.array,
  /** Permission required to view actions which will be passed to protectedContent component */
  permsForActions: PropTypes.array,
  /** This function will be executed when clicked on action from popover */
  onSelectAction: PropTypes.func,
  cardData: PropTypes.object,
};

export default memo(CardActions);
